import styled, { css } from 'styled-components'

export const Container = styled.div`
    input{
        width: 100%;
        border: none;
        border: 1.5px solid #7A05A7;
        border-radius: 5px;
        padding: 0.7rem;
        margin-bottom: 1.5rem;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &[type=number] {
            -moz-appearance: textfield;
        }
    }

    .cardOption{
        padding: 0.7rem;
        border: 1px solid #dadada;
        border-radius: 5px;

        display: flex;
        align-items: center;

        div{
            p{
                margin-top: 0.2rem;
            }
        }

        svg{
            color: #7A05A7;
            margin-right: 1rem;
            font-size: 2rem;
        }

        & + .cardOption{
            margin-top: 1rem;
        }

        @media (min-width: 960px){
            cursor: pointer;
        }
    }

    .realInputDiscount{
        overflow: hidden;
        transition: all 0.2s;
        margin-top: 1rem;

        p{
            font-weight: 500;
            margin-bottom: 0.4rem;
        }

        ${props => props.realCouponType && css`
            max-height: ${props.realCouponType};
        `}
    }

    .percentInputDiscount{
        overflow: hidden;
        transition: all 0.2s;
        margin-top: 1rem;

        p{
            font-weight: 500;
            margin-bottom: 0.4rem;
        }

        ${props => props.percentageCouponType && css`
            max-height: ${props.percentageCouponType};
        `}
    }
`